// extracted by mini-css-extract-plugin
module.exports = {"pkgName":"_15da84c7 pl1 truncate b","linkButton":"c4533b7b","mr6px":"_28f7ffc8"};